import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ImageLightBox from '../../components/image-light-box';

/**
 * Styled container element
 */
const Container = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-rows: auto;
  padding: 1em 0;
  grid-template-columns: 1fr 1fr;
`;

/**
 * Styled image
 */
const Image = styled.img`
  -webkit-tap-highlight-color: transparent;
  width: 100%;
  cursor: pointer;
  &:nth-child(n + 3) {
    margin-top: -1.2em;
  }
`;

/**
 * Gallery component
 * Provides ability to scroll through images
 */
class Gallery extends PureComponent {
  state = {
    open: false
  };

  openModel = event => {
    const src = event.currentTarget.dataset.src;
    this.setState({
      open: src
    });
  };

  closeModal = () => {
    this.setState({
      open: false
    });
  };

  /**
   * @inheritDoc
   */
  render() {
    return (
      <Container>
        {this.props.images.map((url, index) => (
          <Image
            alt=""
            data-src={url}
            key={index}
            onClick={this.openModel}
            src={url}
          />
        ))}
        {this.state.open && (
          <ImageLightBox
            canDownload={this.props.canDownload}
            onClose={this.closeModal}
            src={this.state.open}
          />
        )}
      </Container>
    );
  }
}

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  canDownload: PropTypes.bool
};

export default Gallery;
